import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { OverlaysModule } from "../../../core/utils/overlays/overlays.module";

import { IconModule } from "../icon/icon.module";

import { TooltipIconComponent } from "./tooltip-icon.component";
import { TooltipStaticDirective } from "./tooltip-static.directive";
import { TooltipComponent } from "./tooltip.component";

@NgModule({
  imports: [CommonModule, IconModule, OverlaysModule],
  declarations: [
    TooltipComponent,
    TooltipIconComponent,
    TooltipStaticDirective
  ],
  entryComponents: [TooltipComponent],
  exports: [TooltipIconComponent, TooltipStaticDirective, TooltipComponent]
})
export class TooltipModule {}
